import { Card, CardBody, Col } from "reactstrap";
import { Sizes } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { SIZE_DATA, SIZE_IMAGES } from "../../../../Data/UiKit/Avatars";
import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";

export const SizesCart = () => {
  return (
    <Col xl="4" md="6">
      <Card className="height-equal">
        <CommonCardHeader title={Sizes} span={SIZE_DATA} />
        <CardBody className="avatar-showcase">
          <div className="avatars">
            <div className="avatar">
              <Image className="img-100 rounded-circle" src={dynamicImage("avtar/3.jpg")} alt="image" />
            </div>
            {SIZE_IMAGES.map(({ className, src }, index) => (
              <div className="avatar" key={index}>
                <Image className={`${className} rounded-circle`} src={src} alt="image" />
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
